<template>
  <div id="temp"></div>
</template>

<script>
export default {
  name: "ReportPrint"
}
</script>

<style scoped>

</style>
